<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Crea una bodega</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm form-group">
							<label for="code" class="form-label">Código</label>
							<input type="text" [(ngModel)]="newWarehouse.code" placeholder="Ingresa el código"
								name="code" id="code" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="number" class="form-label">Número</label>
							<input type="text" [(ngModel)]="newWarehouse.number" placeholder="Ingresa el número"
								name="number" id="number" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="name" class="form-label">Nombre <span class="required">*</span></label>
							<input type="text" [(ngModel)]="newWarehouse.name" placeholder="Ingresa el nombre"
								name="name" id="name" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="" class="form-label">Pais <span class="required">*</span></label>
							<select [disabled]="countries.length == 0" name="" id="" class="form-select"
								(change)="getDepartments()" [(ngModel)]="newWarehouse.country">
								<option *ngFor="let country of countries" value="{{country.id}}">{{country.name}}
								</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="" class="form-label">Departamento <span class="required">*</span></label>
							<select [disabled]="departments.length == 0" name="" id="" class="form-select"
								(change)="getTowns()" [(ngModel)]="newWarehouse.department">
								<option *ngFor="let department of departments" value="{{department.id}}">
									{{department.name}}</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="" class="form-label">Ciudad <span class="required">*</span></label>
							<select [disabled]="towns.length == 0" name="" id="" class="form-select"
								[(ngModel)]="newWarehouse.town">
								<option *ngFor="let town of towns" value="{{town.id}}">{{town.name}}</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<label for="storeCategory" class="form-label">Tipo de Bodega <span
									class="required">*</span></label>
							<select name="storeCategory" [(ngModel)]="newWarehouse.storeCategory" id="storeCategory"
								class="form-select">
								<option *ngFor="let category of warehouseCategories" value="{{category.id}}">
									{{category.category}}</option>
							</select>
						</div>
					</div>
					<div class="row mb-4">
						<div class="col-sm form-group">
							<label for="address" class="form-label">Direccion</label>
							<input type="text" name="address" id="address" placeholder="Ingresa la dirección"
								[(ngModel)]="newWarehouse.address" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="manager" class="form-label">Encargado</label>
							<select name="manager" [(ngModel)]="newWarehouse.manager" id="manager" class="form-select">
								<option value="0">Selecciona un encargado</option>
								<option *ngFor="let user of users" value="{{user.id}}">
									{{user.email+((user.firstName!='')?' - '+user.firstName:'')}}</option>
							</select>
						</div>
						<div class="col-sm form-group" [appCheckPermission]="[5042]" [permissionType]="permissionType.CREATE">
							<div class="row">
								<div class="col-sm form-group">
									<label for="establishmentCode" class="form-label">Código Establecimiento</label>
									<input type="number" [(ngModel)]="newWarehouse.establishmentCode" id="establishmentCode" name="establishmentCode"
										placeholder="Ingresa el código del establecimiento" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="gfaceData" class="form-label">Gface</label>
									<div class="input-group" [class.opacity-50]="!newWarehouse.gface">
										<button [ngClass]="newWarehouse.gface?'btn-primary':'btn-secondary'" class="btn" (click)="newWarehouse.gface = !newWarehouse.gface">
											<i [ngClass]="newWarehouse.gface?'fa-toggle-on':'fa-toggle-off'" class="fa"></i>
										</button>
										<input type="text" disabled [value]="newWarehouse.gface?'Activo':'Inactivo'" class="form-control">
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-sm form-group">
						<div class="row">
							<div class="col-sm form-group">
								<label for="place" class="form-label">Selecciona Ubicacion</label>
								<select name="place" [(ngModel)]="newWarehouse.place" id="place" class="form-select">
									<option [value]="null">Selecciona una Ubicacion</option>
									<option *ngFor="let item of places" value="{{item.id}}">{{item.name}}</option>
								</select>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-sm form-group">
							<label for="maxCapacity" class="form-label">Capacidad Máxima</label>
							<input type="number" [(ngModel)]="newWarehouse.maxCapacity" placeholder="Ingresa la Capacidad Máxima"
								name="maxCapacity" id="maxCapacity" class="form-control" min="0">
						</div>
						<div class="col-sm form-group">
							<label for="manager" class="form-label">Selecciona Medida de Capacidad</label>
							<select [disabled]="catalogs && measurementsWeight.length == 0" name="manager" [(ngModel)]="newWarehouse.unitMeasureCapacity" id="manager" class="form-select">
								<option value="0">Selecciona una Medida</option>
								<option *ngFor="let item of measurementsWeight" value="{{item.id}}" >
									{{item.unit}}</option>
							</select>
						</div>
						<div class="col-sm form-group">
							<div class="row">
								<div class="col-sm form-group">
									<label for="manager" class="form-label">Selecciona Tipo</label>
									<select name="manager" [(ngModel)]="newWarehouse.type" id="manager" class="form-select">
										<option value="0">Selecciona un Tipo</option>
										<option value="1">Cilindro</option>
										<option value="2">Contenedor</option>
										<!-- <option *ngFor="let user of users" value="{{user.id}}">
											{{user.email+((user.firstName!='')?' - '+user.firstName:'')}}</option> -->
									</select>
								</div>
							</div>
						</div>
						
					</div>
					<div class="row">
						<div class="col-sm form-group" *ngIf="newWarehouse.type && newWarehouse.type==1">
							<label for="ratio" class="form-label">Radio (metro)</label>
							<input type="number" [(ngModel)]="newWarehouse.ratio" placeholder="Ingresa el Radio"
								name="ratio" id="ratio" class="form-control" min="0">
						</div>
						<div class="col-sm form-group" *ngIf="newWarehouse.type && newWarehouse.type==1">
							<label for="diameter" class="form-label">Diámetro (metro)</label>
							<input type="number" [(ngModel)]="newWarehouse.diameter" placeholder="Ingresa el Diámetro"
								name="diameter" id="diameter" class="form-control" min="0">
						</div>

						<div class="col-sm form-group" *ngIf="newWarehouse.type && newWarehouse.type==2">
							<label for="height" class="form-label">Altura (metro)</label>
							<input type="number" [(ngModel)]="newWarehouse.height" placeholder="Ingresa la Altura"
								name="height" id="height" class="form-control" min="0">
						</div>

						<div class="col-sm form-group" *ngIf="newWarehouse.type && (newWarehouse.type==1 || newWarehouse.type==2)">
							<label for="length" class="form-label">Largo (metro)</label>
							<input type="number" [(ngModel)]="newWarehouse.length" placeholder="Ingresa el Largo"
								name="length" id="length" class="form-control" min="0">
						</div>
						
						<div class="col-sm form-group" *ngIf="newWarehouse.type && newWarehouse.type==2">
							<label for="width" class="form-label">Ancho (metro)</label>
							<input type="number" [(ngModel)]="newWarehouse.width" placeholder="Ingresa el Ancho"
								name="width" id="width" class="form-control" min="0">
						</div>
						
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar la bodega</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="!newWarehouse.name || !newWarehouse.country || !newWarehouse.department || !newWarehouse.town || !newWarehouse.storeCategory || loading"
						(click)="postWarehouse()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>